'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('login', {
    url: '/login/',
    templateUrl: '/views/login.html',
    controller: 'LoginCtrl',
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('Login - Opencare');
      },
      auth: authorizationProvider.requireUnauthorizedUser,
    },
    data: {
      hideNavigation: true,
    },
  });
});

angular.module('ClinicApp').controller('LoginCtrl', function(
  $location,
  $scope,
  UserService,
  ClinicConfig,
  CurrentUser,
  OCAnalyticsUtil,
  IframeService,
) {

  const loginUrl = `${ClinicConfig.CLINIC_APP_V4_URL}/#/login/`;

  angular.element('#js-login-iframe')[0].src = encodeURI(loginUrl);

  $scope.handleLoginSuccess = function() {
    CurrentUser.update(function() {

      // Important. Identify user to have correct statistics.
      OCAnalyticsUtil.bootUserAnalytics();

      var nextUrl = $location.search().nextUrl;
      if (nextUrl) {
        $location.url(decodeURIComponent(nextUrl));
      } else {
        $location.path('/');
      }
    });
  };

  $scope.goToSelfServeFunnel = function(userId) {
    return UserService.logout().then(function() {
      CurrentUser.update(function() {
        const selfServeUrl = `${ClinicConfig.CLINIC_APP_V4_URL}/#/register/?resumeBilling=true&user=${userId}`;
        window.location.href = selfServeUrl;
      });
    });
  };

  IframeService.setupFunctionCallHandler($scope);
});
